import { helpers } from '../helpers.js';

var langs = {
	selectors: { },

	init: function () {
		const self = this;

		const preferredLanguage = self.getPreferredLanguage();

		if( preferredLanguage != null ) {
			self.showLangAlert( preferredLanguage );
		}
	},

	getPreferredLanguage: function() {
		const self = this;

		// Getting the current URL
		const url = window.location.href;
	
		// Checking if "#pref_lang=cs" is in the URL
		const match = url.match(/#pref_lang=([^&]+)/);
	
		// If the match is found, return the value after the equal sign
		if (match && match[1]) {
			return match[1];
		}
	
		// Return null if no matching value is found
		return null;
	},

	showLangAlert: function( lang ) {
		helpers.pctApiCall({
			action: 'get_lang_warning_message',
			lang: lang,
		}).then( response => {
			if( ! response.success ) {
				console.error( 'Error: ', response.data.message ); 
				return false;
			}

			jQuery( response.data.lang_error_big_html ).insertAfter( 'header.header' );
			jQuery( '.navigation__item--pll-parent-menu-item ul' ).append( response.data.lang_error_small_html );

		}).catch(error => {
			console.error( 'Error: ', error); 
		});
	}
};

export { langs };